import { IPlugin, PluginSize, UIPluginAttachPoint } from "@gtmhub/plugins";

export const getPluginIFrameElement = (params: { accessPoint: UIPluginAttachPoint; plugin: IPlugin }): HTMLIFrameElement => {
  return document.getElementById(`${params.accessPoint}-${params.plugin.uiPlugin.src}`) as HTMLIFrameElement;
};

const pluginSizeMap = {
  goalForm: {
    width: 678,
    height: 400,
  },
  metricForm: {
    width: 460,
    height: 400,
  },
};

export const getPluginSize = (accessPoint: UIPluginAttachPoint): PluginSize => {
  return pluginSizeMap[accessPoint];
};

export const navigateToAppSettingsInMarketplace = (pluginVersionId: string): void => {
  window.open(`${location.origin}/marketplace/applications/settings?pluginVersionId=${pluginVersionId}`, "_self");
};

export const EXISTS_IN_THIS_FIELD = "exists-in-this-field";
export const EXISTS_IN_OTHER_FIELDS = "exists-in-other-fields";
